module.exports = __webpack_public_path__ + "img/113363b.png";